var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-external-link-menu';
                    var viewUrl = 'gfx/sprite.svg#view-icon-external-link-menu';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };